import { Box, Typography } from '@mui/material';
import type React from 'react';

type Props = {
  id: string;
  sectionTitle: string;
  isCentralized?: boolean;
};

export const SectionTitle = ({
  sectionTitle,
  id,
  isCentralized = true,
}: Props): React.JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: 2,
        maxWidth: { xs: '100%', md: '82%' },
        ...(isCentralized && {
          marginX: 'auto',
        }),
        marginBottom: 2,
      }}
    >
      <Typography variant="titleSmall" data-testid="offers-count" component="h2" id={id}>
        {sectionTitle}
      </Typography>
    </Box>
  );
};
